import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const RealtimeWidget = ({ initialCount = 247 }) => {
  const [activeUsers, setActiveUsers] = useState(initialCount);
  const [recentActivity, setRecentActivity] = useState([
    { id: 1, page: "/blog/seo-best-practices", time: "2s ago", location: "United States", locationIcon: "MapPin" },
    { id: 2, page: "/pricing", time: "5s ago", location: "United Kingdom", locationIcon: "MapPin" },
    { id: 3, page: "/features/content-editor", time: "8s ago", location: "Canada", locationIcon: "MapPin" },
    { id: 4, page: "/templates/business", time: "12s ago", location: "Australia", locationIcon: "MapPin" },
    { id: 5, page: "/blog/content-strategy", time: "15s ago", location: "Germany", locationIcon: "MapPin" }
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveUsers(prev => {
        const change = Math.floor(Math.random() * 10) - 5;
        return Math.max(200, Math.min(300, prev + change));
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-success animate-pulse" />
          <h3 className="text-base md:text-lg font-semibold text-foreground">Real-time Activity</h3>
        </div>
        <button className="flex items-center gap-2 px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground hover:bg-muted rounded-md transition-colors">
          <Icon name="RefreshCw" size={16} />
          <span className="hidden sm:inline">Refresh</span>
        </button>
      </div>
      <div className="mb-6 p-4 bg-primary/5 rounded-lg border border-primary/20">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Active Users</p>
            <p className="text-3xl md:text-4xl font-bold text-primary">{activeUsers}</p>
          </div>
          <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="Users" size={32} className="text-primary md:w-10 md:h-10" />
          </div>
        </div>
      </div>
      <div className="space-y-3">
        <h4 className="text-sm font-medium text-foreground">Recent Page Views</h4>
        {recentActivity?.map((activity) => (
          <div 
            key={activity?.id} 
            className="flex items-start gap-3 p-3 rounded-lg hover:bg-muted/50 transition-colors"
          >
            <div className="w-8 h-8 rounded-full bg-success/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Eye" size={16} className="text-success" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground truncate">{activity?.page}</p>
              <div className="flex items-center gap-2 mt-1">
                <Icon name={activity?.locationIcon} size={12} className="text-muted-foreground flex-shrink-0" />
                <span className="text-xs text-muted-foreground">{activity?.location}</span>
                <span className="text-xs text-muted-foreground">•</span>
                <span className="text-xs text-muted-foreground">{activity?.time}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RealtimeWidget;